import { MediaMatcher } from "@angular/cdk/layout";
import { NavigationStart, Router } from "@angular/router";
import { interval, Subscription } from 'rxjs';
import { AdminService } from "../../main/admin/admin-management/admin.service";
import { Observable } from 'rxjs';
import * as moment from 'moment';



import {
  ChangeDetectorRef,
  Component,
  NgZone,
  OnDestroy,
  ViewChild,
  HostListener,
  Directive,
  AfterViewInit,
  OnInit,
  ElementRef
} from "@angular/core";
import { MenuItems } from "../../shared/menu-items/menu-items";
import { CommonService } from "../../shared/common.service";

import { StreamService } from "../../shared/stream.service";
import {
  ModalDismissReasons,
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";

declare var $: any;
/** @title Responsive sidenav */
@Component({
  selector: "app-full-layout",
  templateUrl: "full.component.html",
  styleUrls: ["full.component.scss"],
  // animations: [
  //   trigger('routerTransition', [
  //     transition('* <=> *', [
  //       query(':enter, :leave', style({ position: 'fixed', opacity: 0 }),{ optional: true }),
  //       group([
  //         query(':enter', [
  //           style({ opacity:0 }),
  //           animate('600ms ease-in-out', style({ opacity:0 })),

  //         ],{ optional: true }),
  //         query(':leave', [
  //           style({ opacity:0.5 }),
  //           animate('600ms ease-in-out', style({ opacity:0 }))],{ optional: true }),
  //       ])
  //     ])
  //   ])
  //  ]
})
export class FullComponent implements OnDestroy, AfterViewInit, OnInit {
  mobileQuery: MediaQueryList;
  isMenuOpen = true;
  contentMargin: number;
  activeIndex: any;
  message: number;
  filterMessage: any;
  public screenWidth: any;
  public screenHeight: any;
  isMobile: boolean = false;
  detail: any;
  Name: string;
  routeName: string;
  profilePic: string;
  headerTitle = [];
  filterVal: string;
  userData: any;
  userRole: any;
  showScroll: boolean = true;
  isLoading: boolean = false;
  isPodcast: boolean = false;
  NoScroll = ["Search", "My Matches", "My Favorites"];
  currentScreenWidth: any;
  currentNavition: any;
  adminFilterAccess: [2, 3, 4, 5];
  private _mobileQueryListener: () => void;
  private routerSubscription: Subscription;  // ADD THIS LINE AT CLASS LEVEL

  MENUITEMS = [
    {
      state: "admin-dashboard",
      name: "Dashboard",
      iconUrl: "assets/images/Dashboard_icon.svg",
      type: "link",
      iconUrlActive: "assets/images/Dashboard_icon_white.svg",
    },
    // { state: 'admin/coupon-list', name: 'Coupon', iconUrl:"assets/images/driver_grey.svg", type: 'link', iconUrlActive:'assets/images/driver_white.svg'},
    {
      state: "admin/user-list",
      name: "User",
      iconUrl: "assets/images/Managers_icon.svg",
      type: "link",
      iconUrlActive: "assets/images/Managers_icon_white.svg",
    },
    // { state: 'admin/manager-list', name: 'Manager', iconUrl:"assets/images/driver_grey.svg", type: 'link', iconUrlActive:'assets/images/driver_white.svg'},
    {
      state: "admin/vehicle-list",
      name: "Vehicle",
      iconUrl: "assets/images/vehicle_grey.svg",
      type: "link",
      iconUrlActive: "assets/images/vehicle_white.svg",
    },
    {
      state: "admin/booking-list",
      name: "Booking",
      iconUrl: "assets/images/dollar_grey.svg",
      type: "link",
      iconUrlActive: "assets/images/dollar_white.svg",
    },
    {
      state: "admin/driver",
      name: "Driver",
      iconUrl: "assets/images/driver_grey.svg",
      type: "link",
      iconUrlActive: "assets/images/driver_white.svg",
    },

    // {
    //   state: "admin/revenue-list",
    //   name: "Revenue",
    //   iconUrl: "assets/images/driver_grey.svg",
    //   type: "link",
    //   iconUrlActive: "assets/images/driver_white.svg",
    // },
    {
      state: "admin/driver_payment",
      name: "Driver Payment",
      iconUrl: "assets/images/driver_grey.svg",
      type: "link",
      iconUrlActive: "assets/images/driver_white.svg",
    },
    {
      state: "admin/track",
      name: "Track",
      iconUrl: "assets/images/driver_grey.svg",
      type: "link",
      iconUrlActive: "assets/images/driver_white.svg",
    },
  ];
  MENUMANAGER = [
    {
      state: "manager/dashboard",
      name: "Dashboard",
      iconUrl: "assets/images/Dashboard_icon.svg",
      type: "link",
      iconUrlActive: "assets/images/Dashboard_icon_white.svg",
    },
    {
      state: "manager/list-employee",
      name: "Employees",
      iconUrl: "assets/images/Employees_icon.svg",
      type: "link",
      iconUrlActive: "assets/images/Employees_icon_color.svg",
    },
    {
      state: "manager/list-resource",
      name: "Resources",
      iconUrl: "assets/images/Resources_icon.svg",
      type: "link",
      iconUrlActive: "assets/images/Resources_icon_white.svg",
    },
    {
      state: "manager/list-assessment",
      name: "Worksheet",
      iconUrl: "assets/images/Assessment_icon.svg",
      type: "link",
      iconUrlActive: "assets/images/Assessment_icon_white.svg",
    },

    {
      state: "manager/all-skills",
      name: "Skill List ",
      iconUrl: "assets/images/Candidates_icon.svg",
      type: "link",
      iconUrlActive: "assets/images/Candidates_icon_white.svg",
    },
    {
      state: "manager/change-password",
      name: "Change Password ",
      iconUrl: "assets/images/folder_color.svg",
      type: "nolink",
      iconUrlActive: "assets/images/folder_white.svg",
    },
  ];
  MENUEMPLOYEE = [
    {
      state: "employee/dashboard",
      name: "Dashboard",
      iconUrl: "assets/images/Dashboard_icon.svg",
      type: "link",
      iconUrlActive: "assets/images/Dashboard_icon_white.svg",
    },
    {
      state: "employee/list-resource",
      name: "Resources",
      iconUrl: "assets/images/Resources_icon.svg",
      type: "link",
      iconUrlActive: "assets/images/Resources_icon_white.svg",
    },
    {
      state: "employee/list-assessment",
      name: "Worksheet ",
      iconUrl: "assets/images/Candidates_icon.svg",
      type: "link",
      iconUrlActive: "assets/images/Candidates_icon_white.svg",
    },
    {
      state: "employee/change-password",
      name: "Change Password ",
      iconUrl: "assets/images/folder_color.svg",
      type: "nolink",
      iconUrlActive: "assets/images/folder_white.svg",
    },
  ];

  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
  };
  closeResult: string;
  private modalRef: NgbModalRef;

  constructor(
    private eRef: ElementRef,
    private changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    public common: CommonService,
    public adminService: AdminService,
    public router: Router,
    private streamService: StreamService,
    private modalService: NgbModal
  ) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (event.url.startsWith("/main/")) {
          console.log("header", event.url);
          if (event.url == "/main/admin-dashboard") {
            localStorage.setItem("activeIndex", "0");
          }
          if (event.url == "/main/admin/user-list") {
            localStorage.setItem("activeIndex", "1");
          }
          if (event.url == "/main/admin/vehicle-list") {
            localStorage.setItem("activeIndex", "2");
          }
          if (event.url == "/main/admin/booking-list") {
            localStorage.setItem("activeIndex", "3");
          }
          if (event.url == "/main/admin/driver/all") {
            localStorage.setItem("activeIndex", "4");
          }
          if (event.url == "/main/admin/driver/pending") {
            localStorage.setItem("activeIndex", "4");
          }
          if (event.url == "/main/admin/driver_payment") {
            localStorage.setItem("activeIndex", "5");
          }
          this.message = parseInt(localStorage.getItem("activeIndex"));
          this.getHeader();
        }
      }
    });
    this.mobileQuery = media.matchMedia("(min-width: 768px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.showNotificationDropdown = false; // CLOSE dropdown on route change
      }
    });

  }

  notifications = [];
  unreadCount = 0;
  showNotificationDropdown = false;
  notificationSubscription: Subscription;
  isMarkingRead = false; // Keeps track of API call/loading state

  ngOnInit() {
    this.getNotificationListApi();
    // Poll every 30 seconds for new notifications
    this.notificationSubscription = interval(10000).subscribe(() => {
      this.getNotificationListApi();
    });

    this.activeIndex = localStorage.getItem("activeIndex");
    this.userRole = localStorage.getItem("role");
    this.userData = this.common.getUser();
    if (this.userData.role == "admin") {
      this.currentNavition = this.MENUITEMS;
    }
    if (this.userData.role == "employee") {
      this.currentNavition = this.MENUEMPLOYEE;
    }
    if (this.userData.role == "manager") {
      this.currentNavition = this.MENUMANAGER;
    }
    this.message = parseInt(localStorage.getItem("activeIndex"));
    this.getHeader();
    this.streamService.getSubscription().subscribe((message) => {
      this.message = message.data;
      this.getHeader();
    });

    this.streamService.getFilterSubscription().subscribe((data) => {
      console.log(data);

      this.filterMessage = data;
      if (this.filterMessage.length <= 0) {
        this.filterVal = "";
      }
      console.log(this.filterMessage, "FILTERMESSGE");
    });

    $(".rotate").click(function () {
      $(this).toggleClass("down");
    });
    this.currentScreenWidth = screen.width;
    if (this.currentScreenWidth <= 780) {
      this.isMobile = true;
    }
    this.updateUnreadCount();
  }
  updateUnreadCount() {
    this.unreadCount = this.notifications.filter(n => !n.read).length;
  }
  openNotifications() {
    this.showNotificationDropdown = !this.showNotificationDropdown;
    this.markAllAsRead();
  }

  navName: string;
  getHeader() {
    this.headerTitle = this.currentNavition;
    this.navName = this.headerTitle[this.message].name;
  }
  // checkFilterAccessValidation() {
  //   if(this.userData.role = 'admin') {
  //     for(let i =0; i < this.adminFilterAccess.length; i++) {

  //     }

  //   }

  // }
  changePasswordNav() {
    // this.checkFilterAccessValidation()

    if (this.userData.role == "manager") {
      localStorage.setItem("activeIndex", "5");
      this.getHeader();

      this.router.navigate(["/main/manager/change-password"]);
    }
    if (this.userData.role == "employee") {
      localStorage.setItem("activeIndex", "3");
      this.getHeader();
      this.router.navigate(["/main/employee/change-password"]);
    }
    if (this.userData.role == "admin") {
      localStorage.setItem("activeIndex", "10");
      this.getHeader();
      this.router.navigate(["/main/admin/change-password"]);
    }
  }

  logoutUser() {
    this.modalRef.close();
    this.common.logOut();
  }
  filterFunction() {
    let filtervalue = this.filterVal.trim();
    this.streamService.streamFilterMessage(filtervalue);
  }
  enterFilterVal() {
    let filtervalue = this.filterVal.trim();
    this.streamService.streamFilterMessage(filtervalue);
  }

  // navigateSroll() {
  //   this.showScroll = this.NoScroll.indexOf(this.headerTitle) == -1;
  // }

  WindowResize(e) {
    // setTimeout(() => { window.dispatchEvent(new Event('resize')); }, 260);
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
    if (this.notificationSubscription) {
      this.notificationSubscription.unsubscribe(); // cleanup
    }
  }

  readLocalStorageValue(key: string): number {
    return parseInt(localStorage.getItem(key));
  }
  logOut() {
    this.common.logOut();
  }
  ngAfterViewInit() { }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
    if (this.screenWidth <= 780) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }
  openModal(content, btn) {
    this.modelOptions = {
      backdrop: "static",
      keyboard: false,
      size: "sm",
      centered: true,
    };

    btn &&
      btn.parentElement &&
      btn.parentElement.parentElement &&
      btn.parentElement.parentElement.blur();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
  getNotificationListApi() {
    this.adminService.getNotificationListApi("").subscribe(response => {
      if (response && response.data && response.data.notificationArray) {
        this.isMarkingRead = false;

        this.notifications = response.data.notificationArray;
        this.unreadCount = response.data.unreadCount;
      } else {
        this.notifications = [];
        this.unreadCount = 0;
      }
    }, error => {
      console.error('Error fetching notifications', error);
      this.notifications = [];
      this.unreadCount = 0;
    });
  }

  // markAsRead(notification: any) {
  //   if (!notification.read) {
  //     notification.read = true;
  //     this.updateUnreadCount();
  //     // Optionally, call your backend API here to update notification as read
  //     // Example:
  //     // this.adminService.markNotificationAsRead(notification.id).subscribe();
  //   }

  // clearNotifications() {
  //   this.notifications = [];
  //   this.unreadCount = 0;
  //   // Optionally, call backend API to clear notifications there as well
  //   // this.adminService.clearAllNotifications().subscribe();
  // }
  @HostListener("document:click", ["$event"])
  public onClickOutside(event: MouseEvent): void {
    const clickedInsideDropdown = this.eRef.nativeElement.querySelector('.notification-dropdown')?.contains(event.target as Node);
    const clickedBellIcon = this.eRef.nativeElement.querySelector('.bellIcon')?.contains(event.target as Node);

    if (this.showNotificationDropdown && !clickedInsideDropdown && !clickedBellIcon) {
      this.showNotificationDropdown = false;  // close dropdown
    }
  }
  formatNotificationTime(timestamp: number): string {

    return moment.unix(timestamp).format(' MMM D , h:mm A');
  }
  //markAllAsRead api
  markAllAsRead() {
    this.isMarkingRead = true;
    this.adminService.markAllAsRead().subscribe(response => {
      this.getNotificationListApi();
      // this.router.navigate(["main/admin/booking-list"]);
      // this.showNotificationDropdown = false; 
    }, error => {
      console.error('Error marking all notifications as read', error);
      this.isMarkingRead = false;
    }
    );

  }
 // onNotificationClick(n) 
  onNotificationClick(n) {
    // this.router.navigate(["main/admin/booking-list"]);
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(
        ['main/admin/booking-list'],
        { queryParams: { bookingId: n.bookingId } }
      );
    });
    localStorage.setItem("activeIndex", '3');
    this.showNotificationDropdown = false;
  }

}